/**
 * https://www.figma.com/file/16YSFRr06xdFYJFqNgvv41/Bormioli-Product-Design?node-id=48%3A4909
 */

import { Swiper, SwiperSlide } from "@/lib/swiper";
import { useRef } from "react";
import "swiper/css";
import { CursorAPI } from "../Cursor";
import Card, { CardProps } from "./Card";
import { Inner, CarouselWithCardsWrapper } from "./styles";
import CarouselPointer from "../CarouselPointer";

export type CarouselProps = {
  _key?: string;
  variant?: string;
  cards?: CardProps[];
};

/** JavaScript copy-pasted from Locations to fix the problem with padding on big screens */
const CarouselWithCards: React.FC<CarouselProps> = (props) => {
  const { cards, variant = "swipe" } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const cursorRef = useRef<CursorAPI>(null);

  const moveCursor = (x: number, y: number) => {
    cursorRef.current?.moveTo(x, y);
  };
  const fadeInCursor = () => {
    cursorRef.current?.animate({
      opacity: 0.8, // 0.8 is the default for carousels
      duration: 0.3
    });
  };
  const fadeOutCursor = () => {
    cursorRef.current?.animate({
      opacity: 0,
      duration: 0.3
    });
  };

  return (
    <>
      <CarouselPointer
        ref={cursorRef}
        icon={variant === "plus" ? variant : "swipe"}
      />
      <CarouselWithCardsWrapper
        ref={wrapperRef}
        onMouseMove={(e) => {
          const { clientX, clientY } = e;
          moveCursor(clientX, clientY);
        }}
        onMouseEnter={() => fadeInCursor()}
        onMouseLeave={() => fadeOutCursor()}
      >
        <Inner ref={containerRef}>
          <Swiper
            spaceBetween={16}
            slidesPerView={1.5}
            breakpoints={{
              720: { slidesPerView: 2.5, spaceBetween: 40 },
            }}
            style={{
              paddingLeft: "var(--page-margin)",
            }}
            onSliderMove={(_, event) => {
              // console.log(typeof event);
              //if (!(event instanceof TouchEvent)) {
              //  // We are using moveCursors here even though is already present on
              //  //   the mousemove event of the Wrapper because the mousemove event
              //  //   doesn't seem to be fired when the mouse is over the slider area.
              //  moveCursor(event.clientX, event.clientY);
              //}
              if (
                event instanceof MouseEvent ||
                event instanceof PointerEvent
              ) {
                if (event.clientX && event.clientY) {
                  moveCursor(event.clientX, event.clientY);
                }
              }
            }}
          >
            {cards?.map((card, index) => (
              <SwiperSlide key={`${card._key}-${index}`}>
                <Card {...card} fadeInCursorAction={fadeInCursor} fadeOutCursorAction={fadeOutCursor} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Inner>
      </CarouselWithCardsWrapper>
    </>
  );
};

export default CarouselWithCards;
